import React from 'react';
import { Evaluation } from '../App';

interface PreviousRoastsProps {
  evaluations: Evaluation[];
  onSelectEvaluation: (evaluation: Evaluation) => void;
}

const PreviousRoasts: React.FC<PreviousRoastsProps> = ({ evaluations, onSelectEvaluation }) => {
  const formatDate = (dateString?: string) => {
    if (!dateString) return 'Unknown date';
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div className="mt-16 pt-8 border-t border-neutral-light">
      <h2 className="text-critique-primary mb-6 text-2xl md:text-3xl font-display font-bold">Previous Analyses</h2>
      {evaluations.length === 0 ? (
        <p className="text-neutral-lighter italic">No analyses yet. Be the first to submit a paper.</p>
      ) : (
        <div className="grid gap-4">
          {evaluations.map((evaluation) => (
            <div 
              key={evaluation.evaluation_uuid} 
              className="bg-neutral-gray/50 border border-neutral-light rounded-lg p-4 md:p-6 cursor-pointer transition-all hover:bg-neutral-gray hover:border-critique-primary"
              onClick={() => onSelectEvaluation(evaluation)}
            >
              <h3 className="text-critique-primary mb-2 text-lg md:text-xl font-bold">
                {evaluation.paper_title || `Paper ${evaluation.arxiv_paper_id}`}
              </h3>
              <p className="text-neutral-lighter text-sm md:text-base mb-3">
                {evaluation.paper_authors || 'Unknown authors'}
              </p>
              <p className="text-neutral-lighter leading-relaxed mb-4">
                {truncateText(evaluation.full_evaluation_text, 150)}
              </p>
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 text-xs md:text-sm">
                <span className="text-neutral-lighter">{formatDate(evaluation.created_at)}</span>
                <div className="flex gap-2">
                  <span className="bg-critique-primary/10 text-critique-primary px-3 py-1 rounded text-xs self-start sm:self-auto border border-critique-primary/20">
                    {evaluation.prompt_type}
                  </span>
                  {evaluation.prompt_style && (
                    <span className="bg-neutral-gray text-neutral-lighter px-3 py-1 rounded text-xs self-start sm:self-auto border border-neutral-light">
                      {evaluation.prompt_style}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PreviousRoasts;